import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";

import { DataListingComponent } from "./data-listing/data-listing.component";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { Ng2SmartTableModule } from "ng2-smart-table";
import { AlertComponent } from "./alert/alert.component";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { FileUploadComponent } from "./file-upload/file-upload.component";
import { FormsModule } from "@angular/forms";
import { SmartDataListingComponent } from "./smart-data-listing/smart-data-listing.component";
import { PasswordValidatorDirective } from "./forms/password-validator.directive";
import { MethodsService } from "../../shared/methods.service";
import { SharedModule } from "src/app/shared/shared.module";

@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    NgxDatatableModule,
    Ng2SmartTableModule,
    NgbModule,
    FormsModule,
    SharedModule
  ],
  declarations: [
    DataListingComponent,
    AlertComponent,
    FileUploadComponent,
    SmartDataListingComponent,
    PasswordValidatorDirective
  ],
  exports: [
    DataListingComponent,
    AlertComponent,
    FileUploadComponent,
    SmartDataListingComponent,
    PasswordValidatorDirective
  ]
})
export class PartialsModule {}
